import styled from 'styled-components'

export const InputContainer = styled.div`
  display: flex;
  align-items: center;

  & > div:nth-child(2) {
    margin-top: -20px;
    margin-left: -8px;
  }
  & > div:first-child {
    width: 100%;
  }
`

export const DatesContainer = styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: 1fr 1fr;
  justify-content: space-between;
  width: 100%;
`
